// HTML-Escaping für Strings, die in Leaflet-HTML (divIcon, bindTooltip) interpoliert werden.
// React escaped automatisch — Leaflet nicht, daher hier Pflicht (Stored-XSS-Schutz).
export function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export const SAVE_ERROR_MSG = 'Speichern fehlgeschlagen — bitte Verbindung prüfen und erneut versuchen.';
export const CONFLICT_ERROR_MSG = 'Der Lead wurde zwischenzeitlich von jemand anderem geändert — bitte schließen und neu öffnen.';

// Luftlinie in Metern (Haversine) — Nähe-Sortierung der Sidebar
export function distanceMeters(a, b) {
  const R = 6371000, toRad = d => d * Math.PI / 180;
  const dLat = toRad(b.lat - a.lat), dLng = toRad(b.lng - a.lng);
  const s = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
}

export function formatDistance(m) {
  if (!Number.isFinite(m)) return '';
  return m < 1000 ? `${Math.round(m)} m` : `${(m / 1000).toFixed(1).replace('.', ',')} km`;
}

// GPS-Position holen (max. 6 Sekunden, sonst null)
export function getCurrentPosition() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => resolve({ lat: coords.latitude, lng: coords.longitude }),
      ()           => resolve(null),
      { enableHighAccuracy: true, timeout: 6000 }
    );
  });
}

// Gebäudetyp kommt in vielen Schreibweisen ("MFH", "Mehrfamilienhaus 3-6" …) — nach dem
// Excel-Feld, nicht nach anzahl_ne: das ist, was die Liste anzeigt.
export function buildingKind(lead) {
  const v = (lead.gebaeude_typ || '').trim().toLowerCase();
  if (v === 'mfh' || v.startsWith('mehrfamilienhaus')) return 'MFH';
  if (v === 'efh' || v === 'einfamilienhaus' || v === 'zweifamilienhaus') return 'EFH';
  return null;
}
